export default [
    {
        text: 'ID',
        value: 'id',
    },
    {
        text: 'Código Interno',
        value: 'internal_code',
    },
    {
        text: 'Producto',
        value: 'name',
    },
    {
        text: 'Tipo',
        fieldType: 'computed',
        computed: ({ wh_item_id, wh_pack_id, wh_packing_id, wh_promo_id }) => {
            //
            if (wh_item_id) return 'ITEM'
            if (wh_pack_id) return 'PACK'
            if (wh_packing_id) return 'PACKING'
            if (wh_promo_id) return 'PROMO'
            //
            return 'Desconocido'
        },
    }
]